export const FavoritesSection = {
  title: 'Préféré',
  removeButtonTitle: ' Enlever tout',
  more: 'Plus',
  form: 'Formulaire',
  formTitle:
    'Sélectionnez les services qui vous intéressent et remplissez le formulaire afin que nous puissions vous contacter.',
};
